document.addEventListener('DOMContentLoaded', function() {
  const selector = document.getElementById('country-selector');
  if (selector) {
    console.log('Selector found, initializing Select2');
    try {
      $('#country-selector').select2({
        templateResult: formatCountry,
        templateSelection: formatCountry,
        width: '100%',
        minimumResultsForSearch: Infinity // Disable search in dropdown
      });
      console.log('Select2 initialized successfully');
    } catch (error) {
      console.error('Select2 initialization failed:', error);
    }
  } else {
    console.error('Selector not found');
  }
});

function formatCountry(state) {
  if (!state.id) {
    console.log('No state ID, returning text:', state.text);
    return state.text;
  }
  const icon = $(state.element).data('icon');
  console.log('Rendering icon:', icon);
  const flagUrl = `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/6.7.0/flags/4x3/${icon}.svg`;
  return $(`<span><img src="${flagUrl}" class="flag-icon" style="width: 20px; margin-right: 10px;" onerror="console.error('Failed to load flag: ${icon}');" />${state.text}</span>`);
}

function redirectToStore() {
  const selector = document.getElementById('country-selector');
  if (selector) {
    const country = selector.value;
    console.log('Redirecting to:', country);
    const redirects = {
      us: 'https://rattanebike.com',
      uk: 'https://uk.rattanebike.com',
      eu: 'https://eu.rattanebike.com'
    };
    if (redirects[country]) {
      window.location.href = redirects[country];
    } else {
      console.warn('No redirect URL for country:', country);
    }
  } else {
    console.error('Selector not found for redirect');
  }
}